import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Table, TextLink} from "../../../components";
import {elderSubAction} from "redux/actions";
import {useHistory} from "react-router-dom";

function EldSubscriptionsTab({clickedElder, handleCloseModal, setClickedSubscription, handleOpenSubscriptionModal}) {
    const {
        push
    } = useHistory();

    const [tableRows, setTableRows] = useState();

    // Redux actions
    const dispatch = useDispatch();
    const datas = useSelector(state => state.elderSub);

    useEffect(() => {
        console.log(clickedElder);
        dispatch(elderSubAction.get(clickedElder?.id));
        return () => dispatch(elderSubAction.reset());
    }, []);

    useEffect(() => {
        let filtered = datas;
        if (!filtered?.length) {
            setTableRows();
            return;
        }

        // Map table rows
        const data = filtered?.map(obj => ({
            id: obj?.id,
            elder_id: obj?.elder_id,
            package_name: obj?.subscription_package_name,
            // caregiver_name: obj?.primary_caregiver_name,
            // caregiver_relationship_name: obj?.caregiver_relationship_name,
            number_of_bedrooms: obj?.number_of_bedrooms,
            plan_activated_at: `${new Date(obj?.plan_activated_at).toLocaleString()}`,
            plan_expiry_at: `${new Date(obj?.plan_expiry_at).toLocaleString()}`,
            plan_renewal_at: `${new Date(obj?.plan_renewal_at).toLocaleString()}`,
            monitoring_enabled: obj?.monitoring_enabled,
            createdAt: `${new Date(obj?.created_at).toLocaleString()}`,
            updatedAt: `${new Date(obj?.updated_at).toLocaleString()}`
        }));

        setTableRows(data);
    }, [datas]);

    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: "24X7 Subscription"
            },
            {
                title: "Elder"
            },
            {
                title: "Package Name"
            },
            // {
            //     title: "Caregiver Name"
            // },
            // {
            //     title: "Caregiver Relationship"
            // },
            {
                title: "No Of Bedrooms"
            },
            {
                title: "Plan Activated At"
            },
            {
                title: "Plan Expiry At"
            },
            {
                title: "Plan Renewal At"
            },
            {
                title: "Monitoring Enabled"
            },
            {
                title: "Created"
            },
            {
                title: "Updated"
            }
        ],
        [tableRows]
    );

    return (
        <>
            <Table
                headers={tableHeaders}
                data={tableRows}
                current={datas?.currentPage}
                totalPage={datas?.maxPages}
            />
        </>
    );
}

export default EldSubscriptionsTab;